import { render, staticRenderFns } from "./LISSourceSpecimen.vue?vue&type=template&id=640abe40&scoped=true"
import script from "./LISSourceSpecimen.vue?vue&type=script&lang=js"
export * from "./LISSourceSpecimen.vue?vue&type=script&lang=js"
import style0 from "./LISSourceSpecimen.vue?vue&type=style&index=0&id=640abe40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640abe40",
  null
  
)

export default component.exports